
import TheMainContentFrame from "@/components/TheMainContentFrame.vue";
import TheRandomImage from "@/components/TheRandomImage.vue";

export default {
  components: { TheRandomImage, TheMainContentFrame },
  props: {
    categories: Object,
  },
};
